import type { LogPersistedUserEventDto } from '@fruitful/types';
import { useCallback } from 'react';

import { requestBuilder } from '../../http/RequestBuilder';

const useMutateUserEvent = requestBuilder.mutation<
    unknown,
    LogPersistedUserEventDto
>({
    endpoint: '/api/user/events',
    method: 'POST',
});

export const useLogUserEvent = () => {
    const { mutate, mutateAsync, isPending } = useMutateUserEvent();

    const logUserEvent = useCallback(
        (
            eventType: LogPersistedUserEventDto['eventType'],
            metadata?: LogPersistedUserEventDto['metadata'],
        ) => {
            mutate({
                body: {
                    eventType,
                    metadata,
                },
            });
        },
        [mutate],
    );

    const logUserEventAsync = useCallback(
        async (
            eventType: LogPersistedUserEventDto['eventType'],
            metadata?: LogPersistedUserEventDto['metadata'],
        ) => {
            await mutateAsync({
                body: {
                    eventType,
                    metadata,
                },
            });
        },
        [mutateAsync],
    );

    return {
        logUserEvent,
        logUserEventAsync,
        isLoggingUserEvent: isPending,
    };
};
